export const GraphScatter = ({
  fillColor,
  width = '10rem',
}: {
  fillColor: string;
  width?: string;
}) => (
  <svg width={width} viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
    {/* Axes */}
    <line x1='0' y1='0' x2='0' y2='20' stroke={fillColor} strokeWidth={1} />
    <line x1='0' y1='20' x2='20' y2='20' stroke={fillColor} strokeWidth={1} />
    {/* Chart */}
    <path
      d='M 17.5 3a0.5 0.5 0 1 1 1-1 0.5 0.5 0 0 1-1 1z
      m-2 5a0.5 0.5 0 1 0 1-1 0.5 0.5 0 0 0-1 1z
      m-10 8a0.5 0.5 0 1 0-1 1 0.5 0.5 0 0 0 1-1z
      m5-2a0.5 0.5 0 1 0 1-1 0.5 0.5 0 0 0-1 1z
      m0-8a0.5 0.5 0 1 0 1 1 0.5 0.5 0 0 0-1-1z
      '
      stroke='none'
      fill={fillColor}
    />
  </svg>
);
